import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import Checkmark from "assets/images/icons/checkmark.svg";
import ContactCustomerService from "components/auth/ContactCustomerService";

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    background: theme.palette.grey[500],
  },
  browseCatalogBtn: {
    fontSize: 12,
  },
}));

const ResetPasswordSuccess = () => {
  const classes = useStyles();

  return (
    <Box width={1}>
      <Container>
        <Box
          pt={{ xs: 1.5, sm: 5, md: 6 }}
          pb={{ xs: 4, sm: 8, md: 10 }}
          display="flex"
          justifyContent="center"
        >
          <Grid container justifyContent="center">
            <Grid
              item
              container
              direction="column" 
              alignItems="center"
              xs={10} sm={8} md={6}
            >
              <Box mb={3.5}>
                <Typography variant="h1" align="center">
                  Password Reset Success
                </Typography>
              </Box>
              <img
                width={80}
                height={80}
                src={Checkmark}
                alt="Checkmark"
              />
              <Box py={3}>
                <Typography variant="body1" align="center">
                  Your password has been successfully reset. Please continue to
                  browse or visit our home page.
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" m={0}>
                <Box mr={2}>
                  <Button variant="contained" href="/" color="primary">
                    Return home
                  </Button>
                </Box>
                <Button
                  href="/catalog"
                  variant="outlined"
                  color="primary"
                >
                  Browse catalog
                </Button>
              </Box>
              <Box my={{ xs: 4.5, md: 3 }} width={1}>
                <Divider className={classes.divider} />
              </Box>
              <ContactCustomerService conditionText="If you have any questions or concerns" />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ResetPasswordSuccess;
